import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

/**
 * Shown only when the mapping already has fields: importing replaces every one of them, including
 * rectangles drawn and prefill links made by hand.
 */
const ImportFieldsDialog = ({ open, replacedFieldCount, onCancel, onConfirm }) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>Import fields from this PDF?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        This replaces all {replacedFieldCount} field(s) currently mapped, including any boxes and
        prefill links you set by hand, with whatever this PDF&apos;s own form declares. Nothing is
        saved until you choose Save mapping, so you can leave without keeping the import.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button variant="contained" onClick={onConfirm}>
        Replace fields
      </Button>
    </DialogActions>
  </Dialog>
);

export default ImportFieldsDialog;
